import { AsyncState } from '../common/Utils';
import { ChatHistory } from '../api/DomainTypes';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../store';
import { useEffect, useRef } from 'react';
import { SagaActionType } from '../store/sagas/sagaActions';

const useChatHistory = (): AsyncState<ChatHistory> | undefined => {
  const chatHistory = useSelector<RootState, AsyncState<ChatHistory> | undefined>(state => state.chat.currentHistory);
  const messagesLength = chatHistory?.value?.messages.length || 0;

  const prevMessagesLengthRef = useRef(messagesLength);

  const dispatch = useDispatch();

  useEffect(() => {
    if (messagesLength > prevMessagesLengthRef.current || chatHistory === undefined) {
      dispatch({ type: SagaActionType.START_LOAD_HISTORY });
    }
    prevMessagesLengthRef.current = messagesLength;

  }, [chatHistory, messagesLength, dispatch]);

  return chatHistory;
};

export default useChatHistory;
